import { useState, useEffect, useCallback } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PendingBalanceCardForm from "./PendingBalanceCardForm";
import Skeleton from "@mui/material/Skeleton";
import {
  getCardSetupIntent,
  getCards,
} from "../../../../../../../../../services/CreditCard/stripe.services";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
const ELEMENTS_OPTIONS = { appearance: { theme: "stripe" } };

export default function PendingBalanceWrapper({ balance, SetStepCheck }) {
  const [clientSecret, setClientSecret] = useState(null);
  const [cards, setCards] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      const [secretResponse, cardsResponse] = await Promise.all([
        getCardSetupIntent(),
        getCards(),
      ]);

      setClientSecret(secretResponse.data.result.client_secret);
      setCards(cardsResponse.data.result.payment_methods || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Optionally show snackBar
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center w-full h-full">
        <Skeleton
          animation="wave"
          variant="rectangular"
          className="w-4/5 h-32 rounded-md"
        />
      </div>
    );
  }

  return (
    <Elements
      stripe={stripePromise}
      options={{ clientSecret, ...ELEMENTS_OPTIONS }}
    >
      <PendingBalanceCardForm
        balance={balance}
        SetStepCheck={SetStepCheck}
        cards={cards}
      />
    </Elements>
  );
}
